import { useCallback } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import { useErrorMessage } from '../../../../hooks/use-error-message';
import { excludeProgressiveJpegs } from '../../../../utilities/progressive-jpeg-rejection';

/**
 * まとめて注文の画像アップロード導線共通のファイルチェック。
 * jpg以外が混ざっていれば全件拒否、プログレッシブJPEGは除外して残りを返す（通常注文の仕様に合わせる）。
 * どちらの場合も該当ダイアログを表示する。アップロード可能なファイルが無ければ空配列を返す。
 */
export const usePrintUploadFiles = () => {
  const dispatch = useAppDispatch();
  const { pushMessage } = useErrorMessage();

  const filterUploadFiles = useCallback(async (uploadFiles: File[]): Promise<File[]> => {
    if (uploadFiles.find((v) => !['image/jpg', 'image/jpeg'].includes(v.type))) {
      pushMessage(
        '確認',
        [
          'jpgファイルではないものが含まれています。',
          'アップロードするファイルはjpgファイルを選択してください。'
        ],
      );
      return [];
    }
    return excludeProgressiveJpegs(dispatch, uploadFiles);
  }, [
    dispatch,
    pushMessage,
  ]);

  return {
    filterUploadFiles,
  };
};
